<template>
  <div class="ErrorList">
    <el-dialog
        :title="row.userId ? $t('cnumber.cnumber15') : $t('cnumber.cnumber10')"
        :visible="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="handleClose"
        width="620px"
        center
    >
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="auto"
          label-suffix=":"
          class="demo-ruleForm"
        >
          <el-form-item :label="$t('cnumber.cnumber11')" prop="userName">
            <el-input :disabled="row.userId" @input="handleInput" size="small" v-model="ruleForm.userName" :placeholder="$t('loginR.login36')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('cnumber.cnumber12')" prop="clientRoleId">
            <el-select size="small" v-model="ruleForm.clientRoleId">
              <el-option
                  v-for="item in options"
                  :key="item.roleId"
                  :label="item.roleName"
                  :value="item.roleId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('addr.addr4')" prop="realName">
            <el-input size="small" v-model="ruleForm.realName" :placeholder="$t('common.pleaseInput')"></el-input>
          </el-form-item>
          <el-form-item label="Email" prop="emailAddress">
            <el-input size="small" v-model="ruleForm.emailAddress" type="email" :placeholder="$t('loginR.login9')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('changeAccount.changeAccount6')" prop="password">
            <el-input size="small" v-model="ruleForm.password" :placeholder="$t('cnumber.cnumber28')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('cnumber.cnumber9')" prop="userStatus">
            <el-switch
                v-model="ruleForm.userStatus"
                :active-text="$t('cnumber.cnumber6')"
                :inactive-text="$t('cnumber.cnumber7')"
                active-value="0"
                inactive-value="1"
            >
            </el-switch>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" style="display: flex;justify-content: flex-end;">
        <el-button class="form-btn btn-blue" @click="submitForm('ruleForm')">{{ $t('common.confirm' || '确定') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "NumberItem",
  props: {
    row: {
      type: Object,
      default: () => ({})
    },
  },
  data(){
    return {
      ruleForm: {
        userName: '',
        realName: '',
        clientRoleId: '',
        password: '',
        emailAddress: '',
        // lwaExpireTime: '',
        userStatus: '0'
      },
      options: [],
      rules: {
        userName: [
          { required: true, message: this.$t('login.login3'), trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              var reg = /^(?![0-9]+$)(?![a-z]+$)[0-9a-z]{6,20}$/; //6-20位小写字母和数字
              var reg1 = /^[0-9]{6,20}$/; //6-20位数字
              var reg2 = /^[a-z]{6,20}$/; //6-20位小写字母
              var reg3 = /^[A-Z]{6,20}$/; //6-20位大写字母
              if (reg.test(value) || reg1.test(value) || reg2.test(value) || reg3.test(value)) {
                callback();
              } else {
                callback(new Error(this.$t('login.login28')));
              }
            },
            trigger: 'blur'
          }
          // { required: true, message: this.$t('common.pleaseInput') + this.$t('cnumber.cnumber11'), trigger: 'blur' },
        ],
        clientRoleId: [
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('cnumber.cnumber12'), trigger: 'blur' },
        ],
        realName: [
          { required: true, message: this.$t('common.pleaseInput') + this.$t('addr.addr4'), trigger: 'blur' },
        ],
        emailAddress: [
          { required: true, message: this.$t('loginR.login9'), trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const regMobile = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/i;
              if (regMobile.test(value)) {
                callback();
              }
              callback(new Error(this.$t('login.login31')));
            },
            trigger: 'blur'
          }
        ],
        password: [
          { required: true, message: this.$t('loginR.login16'), trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              var reg = /^(?![0-9]+$)(?![A-Z]+$)(?![a-z]+$)[0-9A-Za-z]{6,20}$/; //6-20位小写字母和数字
              if (reg.test(value)) {
                callback();
              } else {
                callback(new Error(this.$t('login.login29')));
              }
            },
            trigger: 'blur'
          }
        ],
      }
    }
  },
  mounted() {
    this.initData()
    if (this.row.userId) {
      this.ruleForm = {...this.row}
      this.rules.password = [
        { required: false, message: this.$t('loginR.login16'), trigger: 'blur' },
        {
          validator: (rule, value, callback) => {
            console.log(value,890)
            var reg = /^(?![0-9]+$)(?![A-Z]+$)(?![a-z]+$)[0-9A-Za-z]{6,20}$/; //6-20位小写字母和数字
            if (reg.test(value) || !value) {
              callback();
            } else {
              callback(new Error(this.$t('login.login29')));
            }
          },
          trigger: 'blur'
        }
      ]
    }
  },
  methods: {
    async initData() {
      // 获取角色列表
      const res = await this.$http.get(
          "/admin/clientRoleListAll",
      );
      // console.log(res,1122)
      this.options = res.data.data
    },
    submitForm(formName) {
      const params = {
        ...this.ruleForm,
        confirmPassword: this.ruleForm.password,
        // menu: JSON.stringify(this.ruleForm.menu),
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.row.userId) {
            // 编辑
            this.$http.post("admin/subAccountUpdate", params).then(res => {
              // console.log(res,11223344)
              if (res.data.code == 200) {
                this.$message({
                  type: "success",
                  message: res.data.message,
                });
                // 父组件更新使用
                this.$options.confirm(true)
              }else {
                this.$message({
                  type: "warning",
                  message: res.data.message,
                });
              }
            });
          }else {
            // 新增
            this.$http.post("admin/subAccountAdd", params).then(res => {
              // console.log(res,112233)
              if (res.data.code == 200) {
                this.$message({
                  type: "success",
                  message: res.data.message,
                });
                // 父组件更新使用
                this.$options.confirm(true)
              }else {
                this.$message({
                  type: "warning",
                  message: res.data.message,
                });
              }
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose () {
      this.$options.cancel('cancel')
    },
    handleInput (val) {
      this.ruleForm.userName = val.toLowerCase();
    }
  }
}
</script>

<style scoped lang="less">
.ErrorList{
  :deep(.el-dialog__body){
    padding: 0 20px;
  }
  :deep(.el-dialog__footer){
    padding: 0 20px 20px;
  }
}

</style>
